// extracted by mini-css-extract-plugin
module.exports = {"root":"rdg_8d928581","rotationFrame":"rdg_17c2f604","inner":"rdg_36e6a9f4"};